export default {
    mounted(el) {
      const input = el.tagName === 'INPUT' || el.tagName === 'TEXTAREA'
        ? el
        : el.querySelector('input, textarea');
  
      if (!input) return;
  
      input.addEventListener('input', () => {
        const start = input.selectionStart;
        const end = input.selectionEnd;
  
        const upper = input.value.toUpperCase();
        if (input.value !== upper) {
          input.value = upper;
          input.dispatchEvent(new Event('input')); // Sync v-model
          input.setSelectionRange(start, end);     // Keep cursor position
        }
      });
    }
  };
  